<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive">
            <el-table border stripe :data="data" class="el-table-css" style="width: 100%">
                <!-- Status Checkmark -->
                <el-table-column width="54" align="center">
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-center">
                            <i v-if="scope.row.issued" class="bi bi-patch-check-fill text-success fs-6" title="Buraxılıb"></i>
                            <i v-else class="bi bi-dash text-muted opacity-50"></i>
                        </div>
                    </template>
                </el-table-column>

                <!-- Contract Number & Status -->
                <el-table-column label="Müqavilə nömrəsi" width="280">
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <a class="doc-number-link" @click="GoToPolicy(scope.row.policyId)">
                                <i class="bi bi-file-earmark-text me-1"></i>{{ scope.row.policyFullNumber }}
                            </a>
                            <span class="status-badge-pill" :class="getStatusBadgeClass(scope.row.policyStatusName)">
                                {{ scope.row.policyStatusName }}
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <!-- Contract Date -->
                <el-table-column prop="contractDateStr" label="Tarix" width="115" align="center">
                    <template #default="scope">
                        <span class="task-time-chip font-monospace">{{ scope.row.contractDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- Company -->
                <el-table-column prop="insured.name" label="Şirkət" min-width="180">
                    <template #default="scope">
                        <span class="fw-bold text-dark-emphasis">
                            <i class="bi bi-building me-1 text-muted"></i>{{ scope.row.insured?.name }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Start Date -->
                <el-table-column prop="startDateStr" label="Başlanma tarixi" width="125" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-muted">{{ scope.row.startDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- End Date -->
                <el-table-column prop="endDateStr" label="Bitmə tarixi" width="125" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-muted">{{ scope.row.endDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- Cancel Date -->
                <el-table-column prop="cancelDateStr" label="Dayandırma tarixi" width="135" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-danger" v-if="scope.row.cancelDateStr">{{ scope.row.cancelDateStr }}</span>
                        <span class="text-muted opacity-50" v-else>—</span>
                    </template>
                </el-table-column>

                <!-- Cancel Type -->
                <el-table-column prop="cancelTypeName" label="Dayandırma növü" width="180">
                    <template #default="scope">
                        <span>{{ scope.row.cancelTypeName || '—' }}</span>
                    </template>
                </el-table-column>

                <!-- Notes -->
                <el-table-column prop="descr" label="Qeydlər" min-width="200">
                    <template #default="scope">
                        <span class="text-muted">{{ scope.row.descr || '—' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array,
        showFilter: Boolean
    },
    methods: {
        GoToPolicy(value) {
            window.open(window.location.origin + '/documents/contract/' + value, "_blank");
        },
        getStatusBadgeClass(statusName) {
            if (!statusName) return "badge--in-progress";
            if (statusName.includes("Aktiv") || statusName.includes("Qüvvədə")) return "badge--approved";
            if (statusName.includes("Dayandırılıb") || statusName.includes("Ləğv") || statusName.includes("düşmüş")) return "badge--rejected";
            return "badge--in-progress";
        }
    }
};
</script>

<style scoped lang="scss">
.task-time-chip {
    font-size: 0.8rem;
    font-weight: 650;
    padding: 2px 6px;
    border-radius: 4px;
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.72rem;
    font-weight: 700;
    white-space: nowrap;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
    &.badge--in-progress {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border: 1px solid rgba(59, 130, 246, 0.35);
    }
    &.badge--rejected {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border: 1px solid rgba(239, 68, 68, 0.35);
    }
}

[data-theme="dark"] {
    .task-time-chip {
        background: #141b22;
        border-color: #283544;
        color: #e2e8f0;
    }

    .status-badge-pill {
        &.badge--approved {
            background: rgba(16, 185, 129, 0.2);
            color: #34d399;
            border-color: rgba(52, 211, 153, 0.35);
        }
        &.badge--in-progress {
            background: rgba(59, 130, 246, 0.2);
            color: #93c5fd;
            border-color: rgba(96, 165, 250, 0.35);
        }
        &.badge--rejected {
            background: rgba(239, 68, 68, 0.2);
            color: #fca5a5;
            border-color: rgba(248, 113, 113, 0.35);
        }
    }
}
</style>